module.exports = __webpack_public_path__ + "static/9-efdd02846ef7034f2c92757b315f1a58.jpeg";